import React from "react";
import Carousel from "react-multi-carousel";

import {
  CarouselWrapper,
  Card,
  Dot,
  ArrowWrapperLeft,
  ArrowWrapperRight,
  ArrowLeft,
  ArrowRight,
} from "./styles.cardSlider";
import { useDimensions } from "../../utils/useDimensions";

export const CardSlider: React.FC = ({ children }) => {
  const { width: deviceWidth } = useDimensions();
  const isMobile = deviceWidth < 700;

  const responsive = {
    insane: {
      breakpoint: { max: Infinity, min: 1601 },
      items: 5,
    },
    future: {
      breakpoint: { max: 1600, min: 1350 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1350, min: 1001 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1000, min: 701 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 700, min: 0 },
      items: 1,
    },
  };

  const CustomButtonGroup = ({
    next,
    previous,
  }: {
    next?: any;
    previous?: any;
  }) => {
    return (
      <>
        <ArrowWrapperLeft
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              previous();
            }
          }}
          onClick={previous}
          isMobile={isMobile}
          tabIndex={0}
          role="button"
        >
          <ArrowLeft />
        </ArrowWrapperLeft>
        <ArrowWrapperRight
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              next();
            }
          }}
          onClick={next}
          isMobile={isMobile}
          tabIndex={0}
          role="button"
        >
          <ArrowRight />
        </ArrowWrapperRight>
      </>
    );
  };

  const CustomDot = ({ onClick, active }: { onClick?: any; active?: any }) => {
    return (
      <li>
        <Dot active={active} onClick={() => onClick()} role="button" />
      </li>
    );
  };

  return (
    <CarouselWrapper isMobile={isMobile}>
      <Carousel
        // centerMode={isMobile}
        responsive={responsive}
        infinite={true}
        showDots={true}
        arrows={false}
        customDot={<CustomDot />}
        customButtonGroup={<CustomButtonGroup />}
        renderButtonGroupOutside={true}
        renderDotsOutside={true}
      >
        {React.Children.map(children, (child) => {
          return <Card>{child}</Card>;
        })}
      </Carousel>
    </CarouselWrapper>
  );
};
